/** Bepaalt feed / story / beide voor een Instagram-kalenderitem. */
export function parsePostAiCopy(post) {
  const raw = post?.ai_copy_json;
  if (raw && typeof raw === 'object') return raw;
  return {};
}

function vbpKindFromPost(post) {
  const copy = parsePostAiCopy(post);
  if (copy.vbp_kind === 'dagknaller' || copy.vbp_kind === 'dagdeal') return copy.vbp_kind;
  const title = String(post?.title || '').toLowerCase();
  if (title.includes('dagknaller')) return 'dagknaller';
  if (title.includes('dagdeal')) return 'dagdeal';
  return 'dagdeal';
}

function vbpDefaultTarget(post, options) {
  const kind = vbpKindFromPost(post);
  if (kind === 'dagknaller') {
    return options.vbpDagknallerTarget || options.vbpPublishTarget || 'both';
  }
  return options.vbpDagdealTarget || options.vbpPublishTarget || 'story';
}

function channelsFromTarget(target, storiesAllowed = true) {
  const t = String(target || 'story').toLowerCase();
  let feed = t === 'feed' || t === 'both';
  let story = storiesAllowed && (t === 'story' || t === 'both');
  if (!storiesAllowed && t === 'story') {
    feed = true;
    story = false;
  }
  return { feed, story };
}

export function instagramPublishPlan(
  post,
  { vbpDagdealTarget = 'story', vbpDagknallerTarget = 'both', vbpStoryEnabled = true } = {}
) {
  const copy = parsePostAiCopy(post);
  const hasFeedFlag = Object.prototype.hasOwnProperty.call(copy, 'instagram_publish_feed');

  let feed;
  if (hasFeedFlag) feed = copy.instagram_publish_feed !== false;
  else if (post?.is_vbp_deal) {
    feed = channelsFromTarget(vbpDefaultTarget(post, { vbpDagdealTarget, vbpDagknallerTarget }), vbpStoryEnabled)
      .feed;
  } else feed = true;

  let story;
  if (post?.instagram_story_auto_publish === true) story = true;
  else if (post?.instagram_story_auto_publish === false) story = false;
  else if (post?.is_vbp_deal) {
    story = channelsFromTarget(vbpDefaultTarget(post, { vbpDagdealTarget, vbpDagknallerTarget }), vbpStoryEnabled)
      .story;
  } else story = false;

  return { feed, story };
}

export function publishPlanLabel(plan) {
  if (plan?.feed && plan?.story) return 'Feed + Story';
  if (plan?.story && !plan?.feed) return 'Story';
  return 'Feed';
}

export function publishPlanShort(plan) {
  if (plan?.feed && plan?.story) return 'Feed · Story';
  if (plan?.story && !plan?.feed) return 'Story';
  return 'Feed';
}

/** API-waarde voor handmatig aanmaken. */
export function targetFromPlan(plan) {
  if (plan.feed && plan.story) return 'both';
  if (plan.story && !plan.feed) return 'story';
  return 'feed';
}

export function planFromTarget(target) {
  const t = String(target || 'feed').toLowerCase();
  if (t === 'story') return { feed: false, story: true };
  if (t === 'both') return { feed: true, story: true };
  return { feed: true, story: false };
}
